import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment-duration-format';
import { StatisticBase, Content, Number } from './Statistic.styles';
import { TextSmall, TextMediumRapid } from '../../common/text';
import { NoDataTextSmall } from '../NoData/NoData';

export const Statistic = ({ heading, value, unit, dimmed, durationFormat }) => {
    let formatted;
    if (value && typeof value === 'number') {
        formatted = durationFormat
            ? moment.duration(value).format(durationFormat, {
                  usePlural: false,
              })
            : parseFloat(value.toFixed(2));
    }

    let realValue = formatted || value;

    return (
        <StatisticBase className="base" dimmed={dimmed}>
            <div>
                <TextMediumRapid noWrap className="heading">
                    {heading}
                </TextMediumRapid>
                <Content>
                    {realValue != null && (
                        <Fragment>
                            <Number className="value" bold={!dimmed}>
                                {realValue}
                            </Number>

                            <TextSmall className="unit">{unit}</TextSmall>
                        </Fragment>
                    )}
                    {realValue == null && <NoDataTextSmall />}
                </Content>
            </div>
        </StatisticBase>
    );
};

Statistic.displayName = 'Statistic';

Statistic.propTypes = {
    heading: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unit: PropTypes.string,
    durationFormat: PropTypes.string,
    dimmed: PropTypes.bool,
};
